{
  "v8e.code.CONFLIT_DE_VERSION": "Someone changed this item in the meantime: reload it and try again.",
  "v8e.code.CONTEXTE_INCOMPLET": "The organisation context is incomplete: reopen the screen from your organisation.",
  "v8e.code.DELEGATION_ALREADY_REVOKED": "This delegation is already revoked.",
  "v8e.code.DELEGATION_DELEGATE_NOT_IN_ORGANISATION": "The delegate is not an active person of the organisation.",
  "v8e.code.DELEGATION_DELEGATOR_ROLE_MISSING": "The delegator does not hold this profile on the chosen item.",
  "v8e.code.DELEGATION_DROIT_RESERVE": "Ownership and owner-reserved rights are never delegated.",
  "v8e.code.DELEGATION_IMMUTABLE": "A delegation cannot be changed: revoke it and declare another one.",
  "v8e.code.DELEGATION_SELF_REFUSED": "A profile cannot be delegated to oneself: choose another delegate.",
  "v8e.code.DELEGATION_WINDOW_INVALID": "The end must be in the future, after the start, and the delegation last {{jours}} days at most.",
  "v8e.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v8e.code.GARDE_DROIT_ABSENTE": "This action is not open yet: no right guard protects it.",
  "v8e.code.NOM_DEJA_PRIS": "This name is already used in the organisation.",
  "v8e.code.ORG_ADMIN_REQUIRED": "This action is reserved to the organisation administration.",
  "v8e.code.RESOURCE_UNAVAILABLE": "This item cannot be found in your organisation.",
  "v8e.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v8e.code.V8E_MODELE_NON_PROPOSE": "This template is not offered by the organisation: choose another one.",
  "v8e.code.VALIDATION_ERROR": "A value was rejected: check the highlighted fields.",
  "v8e.commun.etat.chargement": "Loading: {{quoi}}…",
  "v8e.commun.etat.en_cours": "Saving…",
  "v8e.commun.etat.erreur": "{{quoi}} could not be read.",
  "v8e.commun.etat.introuvable": "{{quoi}} cannot be found.",
  "v8e.commun.etat.reessayer": "Retry",
  "v8e.commun.etat.refus": "You are not allowed to see {{quoi}}.",
  "v8e.commun.etat.vide": "Nothing to show.",
  "v8e.commun.geste.annuler": "Cancel",
  "v8e.commun.geste.erreur": "The action did not succeed.",
  "v8e.commun.geste.fermer": "Close",
  "v8e.delegations.adresse_invalide": "This address does not designate a delegation.",
  "v8e.delegations.aucun_objet.programme": "No programme in the organisation.",
  "v8e.delegations.aucun_objet.projet": "No project in the organisation.",
  "v8e.delegations.aucun_profil": "No delegable profile",
  "v8e.delegations.aucun_profil_delegable": "This delegator only holds ownership here, which is never delegated.",
  "v8e.delegations.champ.date_fin": "End date",
  "v8e.delegations.champ.debut": "From",
  "v8e.delegations.champ.declaree_par": "Declared by",
  "v8e.delegations.champ.delegant": "Delegator",
  "v8e.delegations.champ.delegue": "Delegate",
  "v8e.delegations.champ.fin": "Until",
  "v8e.delegations.champ.motif": "Reason",
  "v8e.delegations.champ.objet.programme": "Programme",
  "v8e.delegations.champ.objet.projet": "Project",
  "v8e.delegations.champ.portee": "Applies to",
  "v8e.delegations.champ.revoquee_par": "Revoked by",
  "v8e.delegations.champ.role": "Delegated profile",
  "v8e.delegations.champ.type_objet": "Delegation scope",
  "v8e.delegations.choisir": "Choose a person",
  "v8e.delegations.debut_aide": "Empty: now.",
  "v8e.delegations.declaree": "Delegation declared.",
  "v8e.delegations.declarer": "Declare a delegation",
  "v8e.delegations.delegant_requis": "Choose the delegator.",
  "v8e.delegations.delegue_requis": "Choose the delegate.",
  "v8e.delegations.echeance.date_choisie": "Chosen date",
  "v8e.delegations.echeance.deux_semaines": "Two weeks",
  "v8e.delegations.echeance.une_semaine": "One week",
  "v8e.delegations.etat.active": "Active",
  "v8e.delegations.etat.expired": "Expired",
  "v8e.delegations.etat.revoked": "Revoked",
  "v8e.delegations.etat.scheduled": "Scheduled",
  "v8e.delegations.filtre": "Delegation state",
  "v8e.delegations.filtre.active": "Active",
  "v8e.delegations.filtre.expiree": "Expired",
  "v8e.delegations.filtre.programmee": "Scheduled",
  "v8e.delegations.filtre.revoquee": "Revoked",
  "v8e.delegations.filtre.toutes": "All",
  "v8e.delegations.jamais.propriete": "Never delegated: ownership and owner-reserved rights.",
  "v8e.delegations.jamais.separation": "Separation of duties still applies: the delegate never approves what they created.",
  "v8e.delegations.ligne": "{{role}} from {{delegant}} to {{delegue}} on {{objet}}, until {{fin}}",
  "v8e.delegations.motif_aide": "At least 5 characters; recorded in the log.",
  "v8e.delegations.motif_requis": "The reason needs at least 5 characters.",
  "v8e.delegations.onglet.delegations": "Delegations",
  "v8e.delegations.onglet.reglages": "Settings and emergency stop",
  "v8e.delegations.onglets": "Organisation governance",
  "v8e.delegations.portee.programme": "programme",
  "v8e.delegations.portee.projet": "project",
  "v8e.delegations.recap.maintenant": "Active from now until {{fin}}.",
  "v8e.delegations.recap.programmee": "Scheduled from {{debut}} to {{fin}}.",
  "v8e.delegations.recap.verification": "The delegator’s rights are checked again at each decision: if they lose the profile, the delegation stops acting.",
  "v8e.delegations.revoquer": "Revoke the delegation",
  "v8e.delegations.revoquer.confirmation": "After revocation, the delegate can no longer act on behalf of the delegator.",
  "v8e.delegations.revoquer.confirmer": "Confirm revocation",
  "v8e.delegations.revoquer.reussie": "Delegation revoked.",
  "v8e.delegations.role.contributor": "Contributor",
  "v8e.delegations.role.owner": "Owner",
  "v8e.delegations.role.viewer": "Viewer",
  "v8e.delegations.toutes": "All delegations",
  "v8e.delegations.vide": "No delegation in this state.",
  "v8e.delegations.voir": "View the delegation",
  "v8e.delegations.vous": "You ({{nom}})",
  "v8e.ecran.dialogue-ajouter-attribution-invitation.titre": "Add an assignment to a pending invitation",
  "v8e.ecran.dialogue-annuler-suppression-projet.titre": "Cancel a project’s scheduled deletion",
  "v8e.ecran.dialogue-archiver-projet.titre": "Archive a project — confirmation",
  "v8e.ecran.dialogue-creer-programme.titre": "Create a programme in the organisation",
  "v8e.ecran.dialogue-creer-projet.titre": "Create a project in the organisation",
  "v8e.ecran.dialogue-declarer-delegation.titre": "Declare a delegation during an absence",
  "v8e.ecran.dialogue-rattacher-projet-programme.titre": "Attach a project to a programme, or detach it",
  "v8e.ecran.dialogue-renommer-projet.titre": "Rename a project",
  "v8e.ecran.dialogue-retirer-appartenance.titre": "Remove a person from a project or programme — confirmation",
  "v8e.ecran.dialogue-retirer-attribution-invitation.titre": "Remove an assignment from a pending invitation — confirmation",
  "v8e.ecran.dialogue-supprimer-categorie.titre": "Delete a category — confirmation",
  "v8e.ecran.dialogue-supprimer-projet.titre": "Schedule a project’s deletion (deferred, can be cancelled)",
  "v8e.ecran.organisation-accueil-administration.titre": "Organisation administration home",
  "v8e.ecran.organisation-delegation-fiche.titre": "Delegation — details",
  "v8e.ecran.organisation-delegations.titre": "Organisation delegations",
  "v8e.ecran.organisation-fiche.titre": "My organisation",
  "v8e.ecran.organisation-invitation-fiche.titre": "Invitation — details",
  "v8e.ecran.organisation-journal.titre": "Organisation log",
  "v8e.ecran.organisation-lancement-projet.titre": "Project launch — composition and technologies",
  "v8e.ecran.organisation-lancements.titre": "Project launches to finish",
  "v8e.ecran.organisation-premiers-pas.titre": "First steps of my organisation",
  "v8e.ecran.organisation-programmes.titre": "Organisation programmes",
  "v8e.ecran.organisation-projet-suppression-fiche.titre": "Project deletion request",
  "v8e.ecran.organisation-projets.titre": "Organisation projects",
  "v8e.ecran.organisation-vue-d-ensemble.titre": "Organisation overview"
}
